import React from "react";
import SelectBox from "devextreme-react/select-box";

const SelectBoxDropDown = (props) => {
  const onValueChanged = (e) => {
    props.changeHandler(e.value);
    if (props.onChangeHandler != undefined) {
      props.onChangeHandler(e.value);
    }
    // console.log("Selected Option", e.value);
  };
  return (
    <SelectBox
      placeholder={props.placeholder}
      items={props.data}
      valueExpr={props.valueExpr}
      displayExpr={props.displayExpr}
      value={props.Value}
      onValueChanged={onValueChanged}
      disabled={props.disabled}
      // defaultValue={props.defaultValue}
      //   value={props.value}
      //   onValueChanged={props.onValueChanged}
    />
  );
};

export default SelectBoxDropDown;
